import { Dialog, DialogBackdrop, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { twJoin, twMerge } from 'tailwind-merge';
import { Button } from '../catalyst-ui-kit/button';
import { StyledDialogPanel } from './StyledDialogPanel';

interface Props {
  title?: React.ReactNode;
  open?: boolean;
  children?: React.ReactNode;
  panelClassName?: string;
  childrenContainerClassName?: string;
  backdropClassName?: string;
  className?: string;
  onClose: () => void;
  hideCloseButton?: boolean;
}

export const StyledDialog: React.FC<Props> = ({
  title,
  open,
  children,
  panelClassName,
  childrenContainerClassName,
  backdropClassName,
  className,
  onClose,
  hideCloseButton,
}) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      transition
      className={twJoin(
        'relative z-40 transition duration-300 ease-out data-[closed]:opacity-0',
        className
      )}
    >
      <DialogBackdrop
        className={twMerge('fixed inset-0 bg-black/40', backdropClassName)}
        aria-hidden="true"
        role="presentation"
      />
      <div className="fixed inset-0 flex h-screen w-screen items-start justify-center overflow-y-auto p-4">
        <StyledDialogPanel
          className={twMerge(
            'relative my-auto w-full max-w-[350px] gap-0 border border-borderPrimary p-0',
            panelClassName
          )}
        >
          {title ? (
            <div className="border-b border-borderPrimary p-4">
              <div className="flex items-center justify-between">
                <DialogTitle className="flex items-center space-x-2 text-base font-semibold text-contentPrimary">
                  {title}
                </DialogTitle>
                <Button
                  onClick={onClose}
                  aria-label="Close"
                  plain
                  className={twJoin('size-6 py-0 sm:px-1 sm:py-0', hideCloseButton ? 'hidden' : '')}
                >
                  <XMarkIcon className="!size-6" />
                </Button>
              </div>
            </div>
          ) : (
            <Button
              onClick={onClose}
              aria-label="Close"
              plain
              className={twJoin(
                'absolute right-1 top-1 size-6 py-0 sm:px-1 sm:py-0',
                hideCloseButton ? 'hidden' : ''
              )}
            >
              <XMarkIcon className="!size-5" />
            </Button>
          )}
          <div className={twMerge('p-4', childrenContainerClassName)}>{children}</div>
        </StyledDialogPanel>
      </div>
    </Dialog>
  );
};
